<!-- 排版模板右侧属性面板 -->
<template>
  <div class="property-panel">
    <!-- 空状态 -->
    <div v-if="!module" class="empty-state">
      <i class="el-icon-s-grid empty-icon"></i>
      <p class="empty-title">选择一个模块</p>
      <p class="empty-hint">点击预览区模块右上角的编辑图标，在此配置属性</p>
    </div>

    <!-- 模块编辑区 -->
    <template v-else>
      <!-- 面板头部 -->
      <div class="panel-header">
        <el-tag size="small" :type="moduleTagType">{{ moduleTypeName }}</el-tag>
        <span class="panel-title">属性设置</span>
        <el-button type="text" class="close-btn" @click="$emit('close')">
          <i class="el-icon-close"></i>
        </el-button>
      </div>

      <!-- 可滚动内容区 -->
      <div class="panel-body">
        <el-form
          :model="form"
          label-position="top"
          size="small"
          :rules="rules"
          ref="panelForm"
        >
          <!-- 通用：模块名称 -->
          <el-form-item label="模块名称" prop="name">
            <el-input
              v-model="form.name"
              maxlength="20"
              placeholder="请输入名称（最多20字）"
              clearable
            ></el-input>
          </el-form-item>

          <!-- ===== Type 2: 绑定模块 ===== -->
          <template v-if="module.type === 2">
            <el-divider content-position="left">
              <span class="divider-text">未绑定状态</span>
            </el-divider>
            <el-form-item label="标题" prop="titleName">
              <el-input v-model="form.titleName" maxlength="20" placeholder="未绑定时显示的标题"></el-input>
            </el-form-item>
            <el-form-item label="内容" prop="contentName">
              <el-input
                v-model="form.contentName"
                maxlength="40"
                placeholder="未绑定时显示的内容"
                type="textarea"
                :rows="2"
              ></el-input>
            </el-form-item>
            <el-form-item label="按钮文字" prop="buttonName">
              <el-input v-model="form.buttonName" maxlength="20" placeholder="按钮上的文字"></el-input>
            </el-form-item>
            <el-divider content-position="left">
              <span class="divider-text">已绑定状态</span>
            </el-divider>
            <el-form-item label="标题" prop="titleName2">
              <el-input v-model="form.titleName2" maxlength="20" placeholder="已绑定时显示的标题"></el-input>
            </el-form-item>
            <el-form-item label="内容" prop="contentName2">
              <el-input
                v-model="form.contentName2"
                maxlength="40"
                placeholder="已绑定时显示的内容"
                type="textarea"
                :rows="2"
              ></el-input>
            </el-form-item>
            <el-form-item label="按钮文字" prop="buttonName2">
              <el-input v-model="form.buttonName2" maxlength="20" placeholder="按钮上的文字"></el-input>
            </el-form-item>
            <el-divider content-position="left">
              <span class="divider-text">跳转配置</span>
            </el-divider>
            <jumpType2
              v-if="form.dataList && form.dataList[0]"
              :Jumpurls="form.dataList[0].Jumpurl"
            ></jumpType2>
          </template>

          <!-- ===== Types 1, 3, 5, 8: 图片列表模块 ===== -->
          <template v-if="[1, 3, 5, 8].includes(module.type)">
            <div
              v-for="(item, index) in form.dataList"
              :key="index"
              class="item-block"
            >
              <div class="item-block-header">
                <span class="item-index">图片 {{ index + 1 }}</span>
                <el-button
                  v-if="index > 0"
                  type="text"
                  size="mini"
                  class="remove-btn"
                  @click="removeItem(index)"
                >
                  <i class="el-icon-delete"></i> 删除
                </el-button>
              </div>
              <uploadImg
                v-model="item.imgSrc"
                :imgSize="1"
                :text="getImgHints(module.type)"
              ></uploadImg>
              <div class="sub-section-title">跳转配置</div>
              <jumpType2 :Jumpurls="item.Jumpurl"></jumpType2>
            </div>
            <el-button
              type="dashed"
              class="add-btn"
              size="small"
              @click="addItem"
            >
              <i class="el-icon-plus"></i> 添加图片
            </el-button>
          </template>

          <!-- ===== Type 10: 视频模块 ===== -->
          <template v-if="module.type === 10">
            <div
              v-for="(item, index) in form.dataList"
              :key="index"
              class="item-block"
            >
              <div class="item-block-header">
                <span class="item-index">视频 {{ index + 1 }}</span>
                <el-button
                  v-if="index > 0"
                  type="text"
                  size="mini"
                  class="remove-btn"
                  @click="removeItem(index)"
                >
                  <i class="el-icon-delete"></i> 删除
                </el-button>
              </div>
              <upload-video
                v-model="item.videoSrc"
                :max="2"
                :text="['视频大小500m以内', '视频格式mp4']"
              ></upload-video>
              <div class="sub-section-title">跳转配置</div>
              <jumpType2 :Jumpurls="item.Jumpurl"></jumpType2>
            </div>
            <el-button
              type="dashed"
              class="add-btn"
              size="small"
              @click="addItem"
            >
              <i class="el-icon-plus"></i> 添加视频
            </el-button>
          </template>

          <!-- ===== Type 7: 商品模块 ===== -->
          <template v-if="module.type === 7">
            <div class="list-section-header">
              <span class="list-count">已选商品（{{ goodsList.length }}/6）</span>
              <el-button type="primary" size="mini" @click="dlGoodsShow = true">
                <i class="el-icon-plus"></i> 选择商品
              </el-button>
            </div>
            <div class="card-list">
              <div v-if="goodsList.length === 0" class="card-empty">
                暂无商品，请点击上方按钮添加
              </div>
              <div
                v-for="(goods, idx) in goodsList"
                :key="goods.id"
                class="goods-card"
              >
                <img :src="goods.cover" class="goods-cover" />
                <div class="goods-info">
                  <div class="goods-title">{{ goods.title }}</div>
                  <div class="goods-price">¥{{ goods.price }}</div>
                </div>
                <el-button
                  type="text"
                  size="mini"
                  class="card-remove-btn"
                  @click="removeGoods(idx)"
                >
                  <i class="el-icon-close"></i>
                </el-button>
              </div>
            </div>
          </template>

          <!-- ===== Type 4: 优惠券模块 ===== -->
          <template v-if="module.type === 4">
            <div class="list-section-header">
              <span class="list-count">已选优惠券（{{ couponList.length }}）</span>
              <el-button type="primary" size="mini" @click="dlCouponShow = true">
                <i class="el-icon-plus"></i> 选择优惠券
              </el-button>
            </div>
            <div class="card-list">
              <div v-if="couponList.length === 0" class="card-empty">
                暂无优惠券，请点击上方按钮添加
              </div>
              <div
                v-for="(coupon, idx) in couponList"
                :key="coupon.id"
                class="coupon-card"
              >
                <div class="coupon-info">
                  <div class="coupon-name">{{ coupon.name }}</div>
                  <div class="coupon-detail">
                    满 ¥{{ coupon.leastCost }} 减 ¥{{ coupon.reduceCost }}
                  </div>
                </div>
                <el-button
                  type="text"
                  size="mini"
                  class="card-remove-btn"
                  @click="removeCoupon(idx)"
                >
                  <i class="el-icon-close"></i>
                </el-button>
              </div>
            </div>
          </template>

          <!-- ===== Type 6: 分类商品模块 ===== -->
          <template v-if="module.type === 6">
            <div class="color-group">
              <el-form-item label="背景颜色">
                <div class="color-row">
                  <el-color-picker v-model="form.backgroundColour" size="small"></el-color-picker>
                  <span class="color-value">{{ form.backgroundColour }}</span>
                </div>
              </el-form-item>
              <el-form-item label="选中颜色">
                <div class="color-row">
                  <el-color-picker v-model="form.selectedColor" size="small"></el-color-picker>
                  <span class="color-value">{{ form.selectedColor }}</span>
                </div>
              </el-form-item>
              <el-form-item label="未选中颜色">
                <div class="color-row">
                  <el-color-picker v-model="form.unselectedColor" size="small"></el-color-picker>
                  <span class="color-value">{{ form.unselectedColor }}</span>
                </div>
              </el-form-item>
            </div>
            <el-divider content-position="left">
              <span class="divider-text">商品分类</span>
            </el-divider>
            <div
              v-for="(cat, catIdx) in form.dataList"
              :key="catIdx"
              class="cat-block"
            >
              <div class="cat-block-header">
                <el-input
                  v-model="cat.titleName"
                  size="mini"
                  placeholder="分类名称"
                  maxlength="7"
                  style="width: 120px"
                ></el-input>
                <el-button
                  type="primary"
                  size="mini"
                  @click="openClassifiedGoods(catIdx)"
                >选商品</el-button>
                <el-button
                  v-if="catIdx > 0"
                  type="danger"
                  size="mini"
                  @click="removeCategory(catIdx)"
                >删除</el-button>
              </div>
              <div class="mini-goods-list">
                <div v-if="cat.multipleSelection.length === 0" class="mini-empty">
                  暂无商品
                </div>
                <div
                  v-for="(goods, gi) in cat.multipleSelection"
                  :key="goods.id"
                  class="mini-goods-item"
                >
                  <img :src="goods.cover" class="mini-cover" />
                  <span class="mini-title">{{ goods.title }}</span>
                  <el-button
                    type="text"
                    size="mini"
                    @click="removeClassifiedGoods(catIdx, gi)"
                    class="mini-remove"
                  ><i class="el-icon-close"></i></el-button>
                </div>
              </div>
            </div>
            <el-button
              type="dashed"
              class="add-btn"
              size="small"
              @click="addCategory"
            >
              <i class="el-icon-plus"></i> 添加分类
            </el-button>
          </template>

          <!-- ===== 高级设置（默认折叠） ===== -->
          <el-collapse
            v-if="hasAdvancedSettings"
            v-model="advancedOpen"
            class="advanced-collapse"
          >
            <el-collapse-item name="advanced">
              <template #title>
                <span class="advanced-title">
                  <i class="el-icon-setting"></i> 高级设置
                </span>
              </template>
              <!-- 图片/视频排序 -->
              <template v-if="[1, 3, 5, 8].includes(module.type)">
                <p class="sort-hint">数字越大排序越前</p>
                <div
                  v-for="(item, idx) in form.dataList"
                  :key="idx"
                  class="sort-row"
                >
                  <span class="sort-label">图片 {{ idx + 1 }}</span>
                  <el-input-number
                    v-model="item.sort"
                    :min="1"
                    size="mini"
                    style="width: 100px"
                  ></el-input-number>
                </div>
              </template>
              <template v-if="module.type === 10">
                <p class="sort-hint">数字越大排序越前</p>
                <div
                  v-for="(item, idx) in form.dataList"
                  :key="idx"
                  class="sort-row"
                >
                  <span class="sort-label">视频 {{ idx + 1 }}</span>
                  <el-input-number
                    v-model="item.sort"
                    :min="1"
                    size="mini"
                    style="width: 100px"
                  ></el-input-number>
                </div>
              </template>
              <template v-if="module.type === 7">
                <p class="sort-hint">数字越大排序越前</p>
                <div
                  v-for="goods in goodsList"
                  :key="goods.id"
                  class="sort-row"
                >
                  <span class="sort-label sort-label-goods">{{ goods.title }}</span>
                  <el-input-number
                    v-model="goods.sort"
                    :min="1"
                    size="mini"
                    style="width: 100px"
                  ></el-input-number>
                </div>
              </template>
              <template v-if="module.type === 4">
                <p class="sort-hint">数字越大排序越前</p>
                <div
                  v-for="coupon in couponList"
                  :key="coupon.id"
                  class="sort-row"
                >
                  <span class="sort-label">{{ coupon.name }}</span>
                  <el-input-number
                    v-model="coupon.sort"
                    :min="1"
                    size="mini"
                    style="width: 100px"
                  ></el-input-number>
                </div>
              </template>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </div>

      <!-- 底部操作栏 -->
      <div class="panel-footer">
        <el-button type="primary" size="small" @click="save" style="flex:1">保存</el-button>
        <el-button size="small" @click="$emit('close')" style="flex:1">取消</el-button>
      </div>
    </template>

    <!-- 商品选择子弹窗（商品模块） -->
    <commodity
      v-if="module && module.type === 7"
      :visible.sync="dlGoodsShow"
      :select-list.sync="dialogGoodsList"
      @on-select="onSelectGoods"
      :limit="6"
    ></commodity>

    <!-- 商品选择子弹窗（分类商品模块） -->
    <commodity
      v-if="module && module.type === 6"
      :visible.sync="dlClassifiedGoodsShow"
      :select-list.sync="dialogClassifiedGoodsList"
      @on-select="onSelectClassifiedGoods"
    ></commodity>

    <!-- 优惠券选择子弹窗 -->
    <coupons
      v-if="module && module.type === 4"
      :visible.sync="dlCouponShow"
      :coupon-list.sync="dialogCouponList"
      @on-coupon="onCoupon"
    ></coupons>
  </div>
</template>

<script>
import uploadImg from '@/components/uploadImage/index.vue'
import jumpType2 from '@/components/jumpType/jumpType.vue'
import commodity from '../../../../components/commodity/shop.vue'
import coupons from '../../../../components/coupons/index.vue'

const MODULE_NAMES = {
  1: '专题轮播',
  2: '绑定模块',
  3: '分类模块',
  4: '优惠券模块',
  5: '分类图标',
  6: '分类商品',
  7: '商品模块',
  8: '轮播模块',
  10: '视频模块'
}

const IMG_HINTS = {
  1: ['图片大小500kb以内', '图片格式png/jpg/gif', '图片宽度715px，高度278px'],
  3: ['图片大小500kb以内', '图片格式png/jpg/gif'],
  5: ['图片大小500kb以内', '图片格式png/jpg/gif', '图片宽度187px，高度189px'],
  8: ['图片大小500kb以内', '图片格式png/jpg/gif', '图片宽度750px，高度444px', '同一模块图片高度需一致']
}

const EMPTY_JUMPURL = () => ({ url: null, id: null, classId: null, paramType: '0', value: '' })

export default {
  name: 'PropertyPanel',
  components: {
    uploadImg,
    jumpType2,
    commodity,
    coupons,
    UploadVideo: () => import('@/components/uploadVideo/index.vue')
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    moduleIndex: {
      type: Number,
      default: -1
    }
  },
  computed: {
    moduleTypeName () {
      return this.module ? (MODULE_NAMES[this.module.type] || '未知模块') : ''
    },
    moduleTagType () {
      const types = { 1: '', 2: 'success', 3: 'warning', 4: 'danger', 5: '', 6: 'success', 7: 'warning', 8: '', 10: 'info' }
      return this.module ? (types[this.module.type] || 'info') : 'info'
    },
    hasAdvancedSettings () {
      return this.module && [1, 3, 4, 5, 7, 8, 10].includes(this.module.type)
    }
  },
  watch: {
    module: {
      handler (val) {
        if (!val) {
          this.resetForm()
          return
        }
        this.initForm(val)
      },
      immediate: true
    }
  },
  data () {
    return {
      advancedOpen: [], // 高级设置默认折叠（空数组）
      form: {
        name: '',
        type: null,
        dataList: [],
        titleName: '',
        contentName: '',
        buttonName: '',
        titleName2: '',
        contentName2: '',
        buttonName2: '',
        backgroundColour: '#FFFFFF',
        selectedColor: '#F59A23',
        unselectedColor: '#7F7F7F'
      },
      rules: {
        name: [{ required: true, message: '请输入模块名称', trigger: 'blur' }],
        titleName: [{ required: true, message: '请输入未绑定标题', trigger: 'blur' }],
        contentName: [{ required: true, message: '请输入未绑定内容', trigger: 'blur' }],
        buttonName: [{ required: true, message: '请输入未绑定按钮', trigger: 'blur' }],
        titleName2: [{ required: true, message: '请输入已绑定标题', trigger: 'blur' }],
        contentName2: [{ required: true, message: '请输入已绑定内容', trigger: 'blur' }],
        buttonName2: [{ required: true, message: '请输入已绑定按钮', trigger: 'blur' }]
      },
      // 商品模块
      goodsList: [],
      dlGoodsShow: false,
      dialogGoodsList: [],
      // 优惠券模块
      couponList: [],
      dlCouponShow: false,
      dialogCouponList: [],
      // 分类商品模块
      currentCatIdx: 0,
      dlClassifiedGoodsShow: false,
      dialogClassifiedGoodsList: []
    }
  },
  methods: {
    initForm (mod) {
      if (mod.dataJson) {
        const json = JSON.parse(JSON.stringify(mod.dataJson))
        this.form = Object.assign({}, this.form, json)

        if (mod.type === 7) {
          this.goodsList = json.dataList ? JSON.parse(JSON.stringify(json.dataList)) : []
        }
        if (mod.type === 4) {
          this.couponList = json.dataLitdis ? JSON.parse(JSON.stringify(json.dataLitdis)) : []
        }
      } else {
        this.resetForm()
        this.form.name = mod.name
        this.form.type = mod.type

        if ([1, 3, 5, 8].includes(mod.type)) {
          this.form.dataList = [{ sort: 1, imgSrc: [], paramType: 0, Jumpurl: EMPTY_JUMPURL() }]
        } else if (mod.type === 10) {
          this.form.dataList = [{ sort: 1, videoSrc: [], paramType: 0, Jumpurl: EMPTY_JUMPURL() }]
        } else if (mod.type === 2) {
          this.form.dataList = [{ paramType: 0, Jumpurl: EMPTY_JUMPURL() }]
        } else if (mod.type === 6) {
          this.form.dataList = [{ titleName: '', index: 0, multipleSelection: [] }]
        } else {
          this.form.dataList = []
        }

        this.goodsList = []
        this.couponList = []
      }
    },
    resetForm () {
      this.form = {
        name: '',
        type: null,
        dataList: [],
        titleName: '',
        contentName: '',
        buttonName: '',
        titleName2: '',
        contentName2: '',
        buttonName2: '',
        backgroundColour: '#FFFFFF',
        selectedColor: '#F59A23',
        unselectedColor: '#7F7F7F'
      }
      this.goodsList = []
      this.couponList = []
      this.advancedOpen = []
    },
    getImgHints (type) {
      return IMG_HINTS[type] || ['图片大小500kb以内', '图片格式png/jpg/gif']
    },
    addItem () {
      const type = this.module.type
      if ([1, 3, 5, 8].includes(type)) {
        this.form.dataList.push({
          sort: this.form.dataList.length + 1,
          imgSrc: [],
          paramType: 0,
          Jumpurl: EMPTY_JUMPURL()
        })
      } else if (type === 10) {
        this.form.dataList.push({
          sort: this.form.dataList.length + 1,
          videoSrc: [],
          paramType: 0,
          Jumpurl: EMPTY_JUMPURL()
        })
      }
    },
    removeItem (index) {
      this.form.dataList.splice(index, 1)
      this.form.dataList.forEach((item, i) => { item.sort = i + 1 })
    },
    // 商品模块
    onSelectGoods () {
      const newGoods = this.dialogGoodsList.filter(
        item => !this.goodsList.some(e => e.id === item.id)
      )
      newGoods.forEach(v => { this.$set(v, 'sort', 10) })
      this.goodsList = [...this.goodsList, ...newGoods]
    },
    removeGoods (idx) {
      this.goodsList.splice(idx, 1)
    },
    // 优惠券模块
    onCoupon () {
      const newCoupons = this.dialogCouponList.filter(
        item => !this.couponList.some(e => e.id === item.id)
      )
      newCoupons.forEach(v => { this.$set(v, 'sort', 10) })
      this.couponList = [...this.couponList, ...newCoupons]
    },
    removeCoupon (idx) {
      this.couponList.splice(idx, 1)
    },
    // 分类商品模块
    addCategory () {
      this.form.dataList.push({
        titleName: '',
        index: this.form.dataList.length,
        multipleSelection: []
      })
    },
    removeCategory (idx) {
      this.form.dataList.splice(idx, 1)
      this.form.dataList.forEach((cat, i) => { cat.index = i })
    },
    openClassifiedGoods (catIdx) {
      this.currentCatIdx = catIdx
      this.dlClassifiedGoodsShow = true
      this.dialogClassifiedGoodsList = this.form.dataList[catIdx].multipleSelection
    },
    onSelectClassifiedGoods () {
      const cur = this.form.dataList[this.currentCatIdx].multipleSelection
      const newGoods = this.dialogClassifiedGoodsList.filter(
        item => !cur.some(e => e.id === item.id)
      )
      newGoods.forEach(v => { this.$set(v, 'sort', 10) })
      this.form.dataList[this.currentCatIdx].multipleSelection = [...cur, ...newGoods]
    },
    removeClassifiedGoods (catIdx, gi) {
      this.form.dataList[catIdx].multipleSelection.splice(gi, 1)
    },
    save () {
      this.$refs.panelForm.validate(valid => {
        if (!valid) return

        const type = this.module.type

        // 验证图片/视频不为空
        if ([1, 3, 5, 8].includes(type)) {
          for (let i = 0; i < this.form.dataList.length; i++) {
            if (!this.form.dataList[i].imgSrc || !this.form.dataList[i].imgSrc[0]) {
              this.$message.error(`请上传第 ${i + 1} 张图片`)
              return
            }
          }
        }
        if (type === 10) {
          for (let i = 0; i < this.form.dataList.length; i++) {
            if (!this.form.dataList[i].videoSrc || !this.form.dataList[i].videoSrc[0]) {
              this.$message.error(`请上传第 ${i + 1} 个视频`)
              return
            }
          }
        }
        if (type === 6) {
          for (let i = 0; i < this.form.dataList.length; i++) {
            if (!this.form.dataList[i].titleName) {
              this.$message.error(`请输入第 ${i + 1} 个分类名称`)
              return
            }
            if (!this.form.dataList[i].multipleSelection.length) {
              this.$message.error(`分类「${this.form.dataList[i].titleName || i + 1}」请至少选择一个商品`)
              return
            }
          }
        }

        const params = JSON.parse(JSON.stringify(this.module))
        params.name = this.form.name
        params.isHome = 1

        if (type === 7) {
          this.form.dataList = this.goodsList
          params.remodelAssemblyGoodsAddVOList = this.goodsList
          params.goods = this.goodsList.map(g => ({
            spuId: g.id,
            categoryIndex: 0,
            sort: g.sort
          }))
        }
        if (type === 4) {
          this.form.dataLitdis = this.couponList
          params.remodelAssemblycouponList = this.couponList
          params.coupons = this.couponList.map(c => ({
            couponId: c.id,
            sort: c.sort
          }))
        }
        if (type === 6) {
          params.backgroundColour = this.form.backgroundColour
          const goodsList = []
          for (const cat of this.form.dataList) {
            cat.multipleSelection.forEach(goods => {
              goodsList.push({ spuId: goods.id, sort: goods.sort, categoryIndex: cat.index })
            })
          }
          params.goods = goodsList
        }

        params.dataJson = this.form
        this.$emit('save', params)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.property-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  border-left: 1px solid #e8e8e8;

  // 空状态
  .empty-state {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #c0c4cc;
    padding: 40px 20px;

    .empty-icon {
      font-size: 48px;
      margin-bottom: 16px;
    }

    .empty-title {
      font-size: 14px;
      font-weight: 500;
      color: #909399;
      margin: 0 0 8px;
    }

    .empty-hint {
      font-size: 12px;
      text-align: center;
      line-height: 1.6;
      margin: 0;
      padding: 0 20px;
    }
  }

  // 面板头部
  .panel-header {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #f0f0f0;
    background: #fafafa;
    flex-shrink: 0;

    .panel-title {
      flex: 1;
      font-size: 13px;
      font-weight: 500;
      color: #333;
      margin-left: 8px;
    }

    .close-btn {
      color: #999;
      padding: 0;
      font-size: 16px;

      &:hover {
        color: #f56c6c;
      }
    }
  }

  // 可滚动内容区
  .panel-body {
    flex: 1;
    overflow-y: auto;
    padding: 16px;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background: #ddd;
    }

    // 分割线文字
    .divider-text {
      font-size: 12px;
      color: #909399;
    }

    // 子标题
    .sub-section-title {
      font-size: 12px;
      color: #606266;
      margin: 12px 0 6px;
      font-weight: 500;
    }

    // 图片/视频条目块
    .item-block {
      border: 1px solid #ebeef5;
      border-radius: 4px;
      padding: 12px;
      margin-bottom: 12px;
      background: #fafafa;

      .item-block-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        .item-index {
          font-size: 13px;
          font-weight: 500;
          color: #303133;
        }

        .remove-btn {
          color: #f56c6c;
          padding: 0;
          font-size: 12px;
        }
      }
    }

    // 添加按钮
    .add-btn {
      width: 100%;
      border-style: dashed;
      margin-top: 4px;
    }

    // 卡片列表（商品/优惠券）
    .list-section-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      .list-count {
        font-size: 12px;
        color: #606266;
      }
    }

    .card-list {
      .card-empty {
        text-align: center;
        color: #c0c4cc;
        font-size: 12px;
        padding: 20px;
        border: 1px dashed #e4e7ed;
        border-radius: 4px;
      }

      .goods-card {
        display: flex;
        align-items: center;
        padding: 8px;
        border: 1px solid #ebeef5;
        border-radius: 4px;
        margin-bottom: 6px;

        .goods-cover {
          width: 44px;
          height: 44px;
          object-fit: cover;
          border-radius: 3px;
          flex-shrink: 0;
        }

        .goods-info {
          flex: 1;
          min-width: 0;
          margin: 0 8px;

          .goods-title {
            font-size: 12px;
            color: #303133;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .goods-price {
            font-size: 12px;
            color: #f56c6c;
            margin-top: 2px;
          }
        }

        .card-remove-btn {
          color: #c0c4cc;
          padding: 0;
          flex-shrink: 0;

          &:hover {
            color: #f56c6c;
          }
        }
      }

      .coupon-card {
        display: flex;
        align-items: center;
        padding: 10px 12px;
        border: 1px solid #ebeef5;
        border-radius: 4px;
        margin-bottom: 6px;
        background: #fff8f0;

        .coupon-info {
          flex: 1;
          min-width: 0;

          .coupon-name {
            font-size: 12px;
            font-weight: 500;
            color: #303133;
          }

          .coupon-detail {
            font-size: 11px;
            color: #e6a23c;
            margin-top: 2px;
          }
        }

        .card-remove-btn {
          color: #c0c4cc;
          padding: 0;

          &:hover {
            color: #f56c6c;
          }
        }
      }
    }

    // 颜色组
    .color-group {
      background: #fafafa;
      border-radius: 4px;
      padding: 12px;
      margin-bottom: 12px;
      border: 1px solid #ebeef5;

      .color-row {
        display: flex;
        align-items: center;

        .color-value {
          font-size: 12px;
          color: #909399;
          margin-left: 8px;
        }
      }
    }

    // 分类商品块
    .cat-block {
      border: 1px solid #ebeef5;
      border-radius: 4px;
      margin-bottom: 10px;
      padding: 10px;

      .cat-block-header {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-bottom: 8px;
      }

      .mini-goods-list {
        .mini-empty {
          font-size: 11px;
          color: #c0c4cc;
          text-align: center;
          padding: 8px;
        }

        .mini-goods-item {
          display: flex;
          align-items: center;
          padding: 4px 0;
          border-bottom: 1px solid #f5f5f5;

          .mini-cover {
            width: 28px;
            height: 28px;
            object-fit: cover;
            border-radius: 3px;
            flex-shrink: 0;
          }

          .mini-title {
            flex: 1;
            font-size: 11px;
            color: #606266;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin: 0 6px;
          }

          .mini-remove {
            color: #c0c4cc;
            padding: 0;
            font-size: 12px;

            &:hover {
              color: #f56c6c;
            }
          }
        }
      }
    }

    // 高级设置折叠
    .advanced-collapse {
      margin-top: 16px;
      border-top: 1px solid #f0f0f0;

      .advanced-title {
        font-size: 12px;
        color: #909399;
      }

      .sort-hint {
        font-size: 11px;
        color: #c0c4cc;
        margin: 0 0 8px;
      }

      .sort-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;

        .sort-label {
          font-size: 12px;
          color: #606266;
        }

        .sort-label-goods {
          max-width: 140px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  // 底部操作栏
  .panel-footer {
    display: flex;
    gap: 8px;
    padding: 12px 16px;
    border-top: 1px solid #f0f0f0;
    background: #fafafa;
    flex-shrink: 0;
  }
}
</style>
